import { Typography, Button } from "@mui/material";
import { Box } from "@mui/system";
import theme from "../../../../app/app-theme";

interface PlanBuilderActionButtonsProps {
    onClose: () => void;
    onSave: () => void;
}

const PlanBuilderActionButtons = ({ onClose, onSave }: PlanBuilderActionButtonsProps) => {
    return (
        <Box sx={{ mt: 2, p: 2, border: '1px solid', borderColor: 'divider', borderRadius: 1 }}>
            <Typography variant="body2" color="textSecondary">
                Note: Please ensure all meal items are properly configured.
            </Typography>
            <Typography variant="body2" color="textSecondary">
                If you have any questions, feel free to reach out to our support team.
            </Typography>
            <div style={{ marginTop: "16px" }}>
                <Button variant="contained" sx={{ mr: 1, bgcolor: `${theme.palette.secondary.main}` }} onClick={onClose}>Cancel</Button>
                <Button variant="contained" onClick={onSave}>Save Plan</Button>
            </div>
        </Box>
    );
}

export default PlanBuilderActionButtons;